import Swal from 'sweetalert2';

let isShowingForbidden = false;

export const showForbiddenAlert = (message?: string) => {
  if (isShowingForbidden) return;

  isShowingForbidden = true;

  const text =
    message ||
    'You do not have permission to perform this action. Please contact your administrator if you believe this is a mistake.';

  void Swal.fire({
    icon: 'warning',
    title: 'Access denied',
    text,
    confirmButtonText: 'OK',
    confirmButtonColor: '#556ee6',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false,
  }).finally(() => {
    isShowingForbidden = false;
  });
};
